(function () {
  'use strict';
  var root = document.querySelector('.hsc-hc');
  if (!root) return;
  var history = [], pending = [], dogContext = [], active = null, turn = 0;
  // Session id lives in localStorage for 48h (the server's session-memory TTL) so a reload,
  // or a hop to the tracking page and back, never makes the agent forget the order number
  // the customer already gave. The rendered thread is kept per tab in sessionStorage.
  var SID_KEY = 'hsc_hc_sid', THREAD_KEY = 'hsc_hc_thread', SID_TTL = 48 * 3600 * 1000;
  function readStore(store, key) { try { var raw = store.getItem(key); return raw ? JSON.parse(raw) : null; } catch (error) { return null; } }
  function writeStore(store, key, value) { try { store.setItem(key, JSON.stringify(value)); } catch (error) { /* private mode or quota: memory is best-effort */ } }
  var savedSid = readStore(localStorage, SID_KEY);
  var sid = (savedSid && typeof savedSid.v === 'string' && /^s[a-f0-9]{32}$/.test(savedSid.v) && Date.now() - Number(savedSid.at || 0) < SID_TTL) ? savedSid.v : 's' + crypto.randomUUID().replaceAll('-', '');
  writeStore(localStorage, SID_KEY, {v: sid, at: (savedSid && savedSid.v === sid) ? savedSid.at : Date.now()});
  var persona = null, joined = false, threadLog = [];
  function remember(op) { threadLog.push(op); threadLog = threadLog.slice(-60); writeStore(sessionStorage, THREAD_KEY, {sid: sid, history: history.slice(-32), dogContext: dogContext.slice(-8), name: persona, joined: joined, log: threadLog}); }
  var followingLatest = true;
  var chatThread = root.querySelector('#hscthread');
  if (chatThread) chatThread.addEventListener('scroll', function () {
    followingLatest = chatThread.scrollHeight - chatThread.clientHeight - chatThread.scrollTop < 64;
  });
  function scrollToLatest(force) {
    if (chatThread && (force || followingLatest)) {
      followingLatest = true;
      chatThread.scrollTop = chatThread.scrollHeight;
    }
  }
  function showName(name) {
    if (typeof name !== 'string' || !/^[A-Za-z ]{2,30}$/.test(name)) return;
    persona = name;
    var header = root.querySelector('.who');
    if (header) { header.childNodes[1].nodeValue = ' ' + name + ' '; header.querySelector('.dotav').textContent = name[0]; }
  }
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var api = 'https://happystaffy.app/api/public/help-ask';
  // SIGNED-IN CUSTOMER (16 Oct 2026): Shopify's signed App Proxy tells Signal who is logged in; the short-lived token rides with
  // each question so the assistant reads their orders and never asks for the order number. Logged out = no token, same as before.
  var identity = '';
  function loadIdentity() {
    try {
      fetch('/apps/subs/whoami', {credentials: 'same-origin', headers: {'Accept': 'application/json'}})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && d.ok && d.token) identity = String(d.token); })
        .catch(function () { identity = ''; });
    } catch (error) { identity = ''; }
  }
  loadIdentity();
  function node(tag, text, cls) {
    var element = document.createElement(tag);
    if (text) element.textContent = text;
    if (cls) element.className = cls;
    return element;
  }
  function safeUrl(value, product) {
    try {
      var url = new URL(value);
      if (url.protocol !== 'https:' || url.username || url.password) return null;
      if (product && !['happystaffyco.com', 'www.happystaffyco.com', 'us.happystaffyco.com'].includes(url.hostname)) {
        if (url.origin !== 'https://happystaffy.app' || url.pathname !== '/api/public/cs-agent-click') return null;
        var destination = new URL(url.searchParams.get('to'));
        if (destination.protocol !== 'https:' || destination.username || destination.password || !['happystaffyco.com', 'www.happystaffyco.com', 'us.happystaffyco.com'].includes(destination.hostname)) return null;
        if (!/^[A-Za-z0-9_-]{8,64}$/.test(url.searchParams.get('sid') || '')) return null;
      }
      return url.href;
    } catch (error) { return null; }
  }
  function returnsAction(value) {
    try {
      var url = new URL(value);
      if (!['happystaffyco.com', 'www.happystaffyco.com', 'us.happystaffyco.com'].includes(url.hostname) || url.pathname.replace(/\/$/, '') !== '/apps/redo/returns-portal') return null;
      var configured = root.dataset.returnsPortal;
      return configured ? safeUrl(new URL(configured, location.origin).href, false) || url.href : url.href;
    } catch (error) { return null; }
  }
  // EVERY LINK HAS A NAME (Tom, 25 Oct 2026: "whenever sending a link like returns or something else it should be a clickable link
  // with a title like Returns Portal"). The raw address never shows; the button says where it goes.
  function linkTitle(href){
    var u;try{u=new URL(href);}catch(e){return null;}
    var host=u.hostname.replace(/^www\./,''),path=u.pathname.replace(/\/+$/,'').toLowerCase();
    var nice=function(slug){return decodeURIComponent(String(slug||'')).replace(/[-_]+/g,' ').replace(/\s+/g,' ').trim().replace(/\b\w/g,function(c){return c.toUpperCase();});};
    var carriers={'auspost.com.au':'Australia Post','myteamge.com':'Team Global Express','mytoll.com':'Team Global Express','couriersplease.com.au':'Couriers Please','startrack.com.au':'StarTrack','usps.com':'USPS','tools.usps.com':'USPS','ups.com':'UPS','fedex.com':'FedEx','dhl.com':'DHL','aramex.com.au':'Aramex','sendle.com':'Sendle'};
    if(carriers[host])return 'Track with '+carriers[host];
    if(host==='creators.happystaffy.app')return 'Creator portal';
    if(!/(^|\.)happystaffyco\.com$/.test(host))return host;
    if(path==='/apps/redo/returns-portal')return 'Returns Portal';
    if(path==='/pages/track-order')return 'Track your order';
    if(path==='/pages/help-centre'||path==='/pages/help-center')return 'Help Centre';
    if(/subscri/.test(path))return 'Manage your subscription';
    if(path==='/account'||path.indexOf('/account/')===0)return 'Your account';
    if(path==='/cart')return 'Your cart';
    var m=path.match(/^\/policies\/([a-z-]+)/);if(m)return nice(m[1]);
    m=path.match(/^\/products\/([^/]+)/);if(m)return nice(m[1]);
    m=path.match(/^\/collections\/([^/]+)/);if(m)return 'Shop '+nice(m[1]);
    m=path.match(/^\/pages\/([^/]+)/);if(m)return nice(m[1]);
    if(path==='')return host==='us.happystaffyco.com'?'Our US store':'Happy Staffy Co store';
    return 'Open link';
  }
  function bubble(text) {
    var element = node('div', '', 'msg m');
    var pattern = /(https:\/\/[^\s<>]+|(?:www\.|us\.)?happystaffyco\.com\/[^\s<>]+|creators\.happystaffy\.app\/[^\s<>]+|(?<![@\w.\/])(?:www\.|us\.)?happystaffyco\.com\b(?![@\w\/]))/g;
    var position = 0;
    for (var match of text.matchAll(pattern)) {
      element.append(document.createTextNode(text.slice(position, match.index)));
      var label = match[0].replace(/[.,!?)]*$/, '');
      var url = safeUrl(label.startsWith('https://') ? label : 'https://' + label, false);
      if (url) {
        var action = returnsAction(url);
        var title = action ? 'Returns Portal' : (linkTitle(url) || label);
        var link = node('a', title + ' ↗', 'hsc-chat-action');
        link.href = action || url; link.target = '_blank'; link.rel = 'noopener noreferrer';
        link.setAttribute('aria-label', title + ' (opens in a new tab)');
        element.append(link);
      }
      else element.append(document.createTextNode(label));
      element.append(document.createTextNode(match[0].slice(label.length)));
      position = match.index + match[0].length;
    }
    element.append(document.createTextNode(text.slice(position)));
    return element;
  }
  function renderCards(thread, cards, currency) {
    cards.slice(0, 4).forEach(function (product) {
      var url = safeUrl(product.link, true);
      if (!url) return;
      var card = node('div', '', 'pcard');
      var imageUrl = safeUrl(product.image, false);
      if (imageUrl) { var image = node('img'); image.src = imageUrl; image.alt = String(product.title || ''); image.loading = 'lazy'; image.addEventListener('load', function () { scrollToLatest(false); }); card.append(image); }
      var details = node('div', '', 'pcard-copy'); details.append(node('strong', String(product.title || 'View product')));
      if (typeof product.why === 'string' && product.why.trim()) details.append(node('p', product.why.trim(), 'pcard-why'));
      if (product.price !== null && product.price !== undefined && Number.isFinite(Number(product.price))) {
        var code = currency === 'USD' ? 'USD' : 'AUD';
        details.append(node('p', new Intl.NumberFormat(code === 'USD' ? 'en-US' : 'en-AU', {style:'currency', currency:code}).format(Number(product.price)), 'pr'));
      }
      card.append(details);
      var link = node('a', 'View product'); link.href = url; link.target = '_blank'; link.rel = 'noopener noreferrer'; link.setAttribute('aria-label', 'View ' + String(product.title || 'product') + ' in a new tab'); card.append(link);
      thread.append(card);
    });
  }
  function renderHandoff(thread) {
    if (thread.querySelector('.hsc-handoff')) return;
    var form = node('form', '', 'hsc-handoff');
    var label = node('label', 'Where should our team contact you?');
    var input = node('input'); input.type = 'email'; input.required = true; input.autocomplete = 'email'; input.placeholder = 'you@example.com'; input.value = root.dataset.custEmail || '';
    var button = node('button', 'Send to our team'); button.type = 'submit';
    form.append(label, input, button);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!input.reportValidity()) return;
      button.disabled = true;
      form.remove();
      window.hscAsk('Please pass this to a customer service manager. My email is ' + input.value.trim() + '.');
    });
    thread.append(form);
    input.focus({preventScroll:true});
  }
  // WHERE'S MY ORDER = THE BOX (Tom, 25 Oct 2026). When the reply asks for order details on a tracking question the order box
  // sits right in the chat; a verified order comes back as a tracking card from the same lookup as the tracking page, and a
  // summary goes into the history so the agent carries on from it. A small link keeps the full tracking page one tap away.
  var trackApi = api.replace('/help-ask', '/order-track');
  function trackStyles() {
    if (document.getElementById('hsc-track-css')) return;
    var st = document.createElement('style'); st.id = 'hsc-track-css';
    st.textContent = '.hsc-hc .hsc-track{align-self:stretch;display:grid;gap:8px;background:#fff7f0;border:1.5px solid #f47b2066;border-radius:14px;padding:12px;margin-top:8px}' +
      '.hsc-hc .hsc-track label{font-size:13px;font-weight:800}.hsc-hc .hsc-track input{min-width:0;padding:11px 12px;border:1.5px solid var(--line);border-radius:10px;background:#fff;color:var(--ink);font-size:16px}' +
      '.hsc-hc .hsc-track button{border:0;border-radius:10px;background:var(--orange);color:#fff;font-weight:800;padding:12px 14px;cursor:pointer;min-height:44px}.hsc-hc .hsc-track .err{color:#b42318;font-size:13px}' +
      '.hsc-hc .hsc-track a,.hsc-hc .tcard .full{font-size:12px;color:#666;text-decoration:underline;text-align:center;min-height:36px;display:flex;align-items:center;justify-content:center}' +
      '.hsc-hc .tcard{align-self:stretch;border:1.5px solid var(--line);border-radius:16px;padding:14px;margin-top:10px;background:#fff;box-shadow:0 6px 18px #0000000a}' +
      '.hsc-hc .tcard .top{display:flex;justify-content:space-between;align-items:center;gap:10px}.hsc-hc .tcard .top strong{font-size:15px}.hsc-hc .tcard .top small{display:block;color:#888;font-size:12px;font-weight:400}' +
      '.hsc-hc .tcard .pill{padding:5px 10px;border-radius:999px;font-size:12px;font-weight:800;background:#fff1ea;color:#c2410c;white-space:nowrap}.hsc-hc .tcard .pill.done{background:#eaf6ee;color:#1d6b3a}.hsc-hc .tcard .pill.off{background:#f1f1f1;color:#555}' +
      '.hsc-hc .tcard .steps{display:grid;grid-template-columns:repeat(4,1fr);gap:4px;margin:12px 0}.hsc-hc .tcard .steps div{font-size:11px;color:#aaa;line-height:1.25}.hsc-hc .tcard .steps i{display:block;height:4px;border-radius:9px;background:#eee;margin-bottom:6px}.hsc-hc .tcard .steps .on{color:var(--ink);font-weight:700}.hsc-hc .tcard .steps .on i{background:var(--orange)}' +
      '.hsc-hc .tcard .parcel{border-top:1px solid #eee;padding-top:10px;margin-top:4px;font-size:13px}.hsc-hc .tcard .parcel a.go{display:inline-flex;align-items:center;min-height:40px;font-weight:800;color:#c2410c}.hsc-hc .tcard .items{border-top:1px solid #eee;padding-top:8px;margin-top:8px;font-size:12px;color:#777}';
    document.head.appendChild(st);
  }
  function fmtDate(v) { var t = Date.parse(v || ''); return t ? new Date(t).toLocaleDateString(/^us\./.test(location.hostname) ? 'en-US' : 'en-AU', {weekday:'short', day:'numeric', month:'short'}) : ''; }
  function trackCard(o) {
    var card = node('div', '', 'tcard'), top = node('div', '', 'top'), title = node('strong', 'Order ' + String(o.name || ''));
    if (o.placedAt) title.append(node('small', 'Placed ' + fmtDate(o.placedAt)));
    var step = (o.stage && typeof o.stage.step === 'number') ? o.stage.step : 1, label = (o.stage && o.stage.label) || '';
    top.append(title, node('span', label, 'pill' + (step === 4 ? ' done' : step === 0 ? ' off' : ''))); card.append(top);
    if (step > 0) { var steps = node('div', '', 'steps'); ['Ordered', 'Packed', 'Shipped', 'Delivered'].forEach(function (l, i) { var d = node('div', '', i < step ? 'on' : ''); d.append(node('i'), document.createTextNode(l)); steps.append(d); }); card.append(steps); }
    (Array.isArray(o.tracking) ? o.tracking : []).slice(0, 4).forEach(function (t) {
      var row = node('div', '', 'parcel'); row.append(node('div', String(t.company || 'Courier') + (t.number ? ' · ' + t.number : '')));
      var when = t.deliveredAt ? 'Delivered ' + fmtDate(t.deliveredAt) : t.eta ? 'Expected ' + fmtDate(t.eta) : '';
      if (when) row.append(node('div', when));
      var url = safeUrl(t.url, false); if (url) { var a = node('a', 'Track with ' + String(t.company || 'the courier'), 'go'); a.href = url; a.target = '_blank'; a.rel = 'noopener noreferrer'; row.append(a); }
      card.append(row);
    });
    if (Array.isArray(o.items) && o.items.length) card.append(node('div', o.items.slice(0, 6).join(' · '), 'items'));
    var full = node('a', 'Open the full tracking page', 'full'); full.href = '/pages/track-order'; card.append(full);
    return card;
  }
  function trackSummary(o) {
    var step = (o.stage && typeof o.stage.step === 'number') ? o.stage.step : 1, t = (o.tracking || [])[0] || {};
    var line = 'Order ' + o.name + ': ' + String((o.stage && o.stage.label) || '').toLowerCase() + '.';
    if (step === 4 && t.deliveredAt) line += ' Delivered ' + fmtDate(t.deliveredAt) + '.'; else if (t.eta) line += ' Expected ' + fmtDate(t.eta) + '.';
    if (t.company) line += ' Carrier: ' + t.company + (t.number ? ' ' + t.number : '') + '.';
    return line;
  }
  function renderTrackForm(thread, prefill) {
    var existing = thread.querySelector('.hsc-track'); if (existing) { if (prefill && prefill.number) existing.remove(); else return; }
    trackStyles();
    var form = node('form', '', 'hsc-track'); form.noValidate = true;
    var l1 = node('label', 'Order number'), num = node('input'); num.inputMode = 'numeric'; num.placeholder = 'e.g. 113705'; num.autocomplete = 'off';
    var l2 = node('label', 'Email you ordered with'), em = node('input'); em.type = 'email'; em.autocomplete = 'email'; em.placeholder = 'you@example.com'; em.value = root.dataset.custEmail || '';
    var err = node('div', '', 'err'); err.hidden = true;
    var button = node('button', 'Track order'); button.type = 'submit';
    var page = node('a', 'Prefer the tracking page? Open it here'); page.href = '/pages/track-order';
    form.append(l1, num, l2, em, err, button, page);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var n = num.value.replace(/[^0-9]/g, ''), e = em.value.trim();
      if (n.length < 3 || !/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(e)) { err.textContent = 'Enter your order number and the email you ordered with.'; err.hidden = false; return; }
      err.hidden = true; button.disabled = true; button.textContent = 'Finding your order…';
      fetch(trackApi, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({order:n, email:e})})
        .then(function (r) { return r.json().catch(function () { return {ok:false}; }); })
        .then(function (d) {
          if (!d || !d.ok || !d.order) { err.textContent = d && d.error === 'not_found' ? 'We could not find an order with that number and email. Check both match your confirmation email.' : d && d.error === 'rate' ? 'Please wait a minute and try again.' : 'That did not go through. Please try again.'; err.hidden = false; button.disabled = false; button.textContent = 'Track order'; return; }
          var o = d.order, said = 'Track order #' + n + ' (' + e + ')';
          form.remove();
          thread.append(node('div', said, 'msg u'));
          var summary = trackSummary(o);
          thread.append(bubble(summary)); thread.append(trackCard(o));
          history.push({role:'user', content:said}, {role:'assistant', content:summary}); history = history.slice(-32);
          remember({u: said}); remember({m: summary, cards: [], currency: '', track: o});
          scrollToLatest(true);
        })
        .catch(function () { err.textContent = 'That did not go through. Please try again.'; err.hidden = false; button.disabled = false; button.textContent = 'Track order'; });
    });
    thread.append(form);
    // Number + email already given (25 Oct 2026): look it up straight away, no retyping.
    if (prefill && prefill.number && prefill.email) { num.value = String(prefill.number); em.value = String(prefill.email); setTimeout(function () { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', {cancelable: true})); }, 0); }
    else num.focus({preventScroll:true});
  }
  function fail(thread, message, retry) {
    var box = bubble(message);
    var button = node('button', 'Try again', 'hsc-retry'); button.type = 'button';
    button.addEventListener('click', function () { button.disabled = true; window.hscAsk(retry); });
    box.append(document.createElement('br'), button);
    var contact = node('a', 'Email customer care'); contact.href = 'mailto:support@happystaffyco.com'; box.append(document.createTextNode(' '), contact);
    thread.append(box);
  }
  window.hscOpen = function () {
    var answer = root.querySelector('#hsca'), thread = root.querySelector('#hscthread');
    answer.style.display = 'block';
    if (!thread.children.length) {
      showName('Happy Staffy Support');
      thread.append(bubble('Hi! Tell us what you need help with and we’ll help you work through it.'));
      joined = true;
    }
    answer.scrollIntoView({behavior: reducedMotion ? 'auto' : 'smooth', block:'nearest'});
    var reply = root.querySelector('#hscr');
    if (reply) reply.focus({preventScroll:true});
    return false;
  };
  (function restore() {
    var saved = readStore(sessionStorage, THREAD_KEY);
    if (!saved || saved.sid !== sid || !Array.isArray(saved.log) || !saved.log.length) return;
    var thread = root.querySelector('#hscthread'), answer = root.querySelector('#hsca');
    if (!thread || !answer) return;
    history = Array.isArray(saved.history) ? saved.history : []; dogContext = Array.isArray(saved.dogContext) ? saved.dogContext : [];
    threadLog = saved.log.slice(-60); joined = !!saved.joined;
    if (typeof saved.name === 'string' && saved.name) showName(saved.name);
    saved.log.forEach(function (op) {
      if (op && typeof op.u === 'string') thread.append(node('div', op.u, 'msg u'));
      else if (op && typeof op.m === 'string') { op.m.split('\n\n').forEach(function (part) { if (part.trim()) thread.append(bubble(part)); }); renderCards(thread, Array.isArray(op.cards) ? op.cards : [], op.currency); if (op.track) { trackStyles(); thread.append(trackCard(op.track)); } }
    });
    answer.style.display = 'block';
    scrollToLatest(true);
  })();
  // PHOTO AND VIDEO UPLOAD (Tom, 18 Sep 2026). A customer showing us a broken toy is worth more than
  // any description of it. The file goes straight to the worker, which assesses it and parks the
  // result against this session; the next message the customer sends is answered WITH that context.
  var PHOTO_MAX = 4500000;
  // BIG PHONE PHOTOS (Onyx, live 12 Oct 2026: "I'm not sure why the photos aren't sending"). A modern phone photo is
  // often 5-12MB, over the worker's limit, so the old path refused it with "a photo straight from your phone camera
  // usually works" - the exact thing she was sending. Images are now shrunk in the browser (longest side 1800px,
  // JPEG) before upload; the original is only sent when it is already small or the browser cannot decode it.
  function shrinkImage(file) {
    return new Promise(function (resolve) {
      if (!/^image\//.test(file.type || '') || file.size <= 1500000 || !window.createImageBitmap) { resolve(file); return; }
      var done = false, finish = function (f) { if (!done) { done = true; resolve(f); } };
      setTimeout(function () { finish(file); }, 8000);
      createImageBitmap(file).then(function (bmp) {
        var max = 1800, scale = Math.min(1, max / Math.max(bmp.width, bmp.height));
        var c = document.createElement('canvas'); c.width = Math.round(bmp.width * scale); c.height = Math.round(bmp.height * scale);
        c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
        c.toBlob(function (blob) { finish(blob && blob.size ? new File([blob], (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg', {type: 'image/jpeg'}) : file); }, 'image/jpeg', 0.85);
      }).catch(function () { finish(file); });
    });
  }
  function sendMedia(original) {
    if (!original) return;
    var thread = root.querySelector('#hscthread'), answer = root.querySelector('#hsca');
    answer.style.display = 'block';
    if (!/^(image|video)\//.test(original.type || '')) { thread.append(bubble('That file type will not open for us. A photo or a short video works best.')); return; }
    shrinkImage(original).then(function (file) { sendMediaFile(file, thread); });
  }
  function sendMediaFile(file, thread) {
    if (file.size > PHOTO_MAX) { thread.append(bubble(/^video\//.test(file.type) ? 'That video is a bit too big for the chat. A shorter clip, or a photo, will come through.' : 'That photo is too big to send here. A screenshot of it will come through fine.')); return; }
    var isVid = /^video\//.test(file.type);
    thread.append(node('div', isVid ? 'Video sent' : 'Photo sent', 'msg u'));
    remember({u: isVid ? 'Video sent' : 'Photo sent'});
    scrollToLatest(true);
    fetch(api.replace('/help-ask', '/help-photo'), {method: 'POST', headers: {'Content-Type': file.type, 'x-hsc-sid': sid}, body: file})
      .then(function (r) { return r.json().catch(function () { return {ok: false}; }); })
      .then(function (d) {
        if (!d || !d.ok) { thread.append(bubble('That did not come through. Could you try sending it again?')); return; }
        window.hscAsk(isVid ? "I've sent a video of it." : "I've sent a photo of it.");
      })
      .catch(function () { thread.append(bubble('That did not come through. Could you try sending it again?')); });
  }
  (function wireMedia() {
    var btn = root.querySelector('#hscphotobtn'), file = root.querySelector('#hscphotofile'), drop = root.querySelector('#hscdrop');
    if (btn && file) {
      btn.addEventListener('click', function () { file.click(); });
      file.addEventListener('change', function () { sendMedia(file.files && file.files[0]); file.value = ''; });
    }
    var panel = root.querySelector('#hsca');
    if (!panel) return;
    ['dragenter', 'dragover'].forEach(function (e) { panel.addEventListener(e, function (ev) { ev.preventDefault(); if (drop) drop.hidden = false; }); });
    ['dragleave', 'drop'].forEach(function (e) { panel.addEventListener(e, function (ev) { ev.preventDefault(); if (drop) drop.hidden = true; }); });
    panel.addEventListener('drop', function (ev) { sendMedia(ev.dataTransfer && ev.dataTransfer.files && ev.dataTransfer.files[0]); });
  })();
  window.hscAsk = function (question) {
    question = String(question || '').trim();
    if (!question) return false;
    var thread = root.querySelector('#hscthread'), answer = root.querySelector('#hsca');
    answer.style.display = 'block'; answer.scrollIntoView({behavior:'smooth', block:'nearest'});
    if (question.length > 500) { thread.append(bubble('Please keep each message under 500 characters. You can send the rest as a follow-up.')); return false; }
    thread.append(node('div', question, 'msg u'));
    remember({u: question});
    scrollToLatest(true);
    if (/\b(chew(?:er|ing|s)?|staffy|staffie|breed|puppy|pup|dog|kg|gentle|aggressive|tough|strong|destroy(?:s|er)?)\b/i.test(question)) {
      if (dogContext[dogContext.length - 1] !== question) dogContext.push(question);
      dogContext = dogContext.slice(-8);
    }
    pending.push(question);
    if (active) active.abort();
    var current = ++turn, controller = new AbortController(); active = controller;
    root.querySelectorAll('.stat, .typingrow').forEach(function (status) { status.remove(); });
    var connecting = !joined;
    var status = node('div', connecting ? 'Connecting you to Happy Staffy Support' : '', connecting ? 'stat hsc-search-status' : 'stat'); status.setAttribute('role', 'status'); status.setAttribute('aria-label', connecting ? 'Connecting you to Happy Staffy Support' : 'Reply loading'); thread.append(status);
    if (connecting) { var searchDots = node('span', '', 'hsc-search-dots'); searchDots.setAttribute('aria-hidden', 'true'); searchDots.append(node('span', '.'), node('span', '.'), node('span', '.')); status.append(searchDots); }
    var typing = node('div', '', 'typingrow'); typing.style.display = connecting ? 'none' : 'flex'; typing.setAttribute('aria-hidden', 'true');
    typing.append(node('span'), node('span'), node('span')); thread.append(typing); scrollToLatest(true);
    var questionSent = pending.join('\n');
    if (questionSent.length > 500) { pending = []; active = null; typing.remove(); status.textContent = 'Message too long'; fail(thread, 'Please resend your question in one message under 500 characters.', question); return false; }
    var timer = setTimeout(function () { controller.abort(); }, 40000);
    fetch(api, {method:'POST', headers:{'Content-Type':'application/json'}, signal:controller.signal, body:JSON.stringify({question:questionSent, history:history.slice(-32), customerContext:dogContext.join("\n").slice(-2000), sid:sid, identity:identity})})
      .then(async function (response) {
        var data = await response.json();
        if (current !== turn) return;
        if (!response.ok || !data.ok) throw new Error(data.error === 'rate' ? 'rate' : 'unavailable');
        var parts = (Array.isArray(data.bubbles) ? data.bubbles : []).filter(function (part) { return typeof part === 'string' && part.trim(); });
        if (!parts.length && typeof data.answer === 'string' && data.answer.trim()) parts = [data.answer];
        if (!parts.length) throw new Error('empty');
        clearTimeout(timer);
        if (connecting) {
          showName(data.agentName || persona || 'Support');
          status.textContent = ''; status.className = 'stat';
          var joinLine = node('div', persona + ' has joined the chat', 'hsc-join-line');
          joinLine.setAttribute('role', 'status'); thread.insertBefore(joinLine, typing); joined = true;
        }
        status.remove();
        pending = [];
        history.push({role:'user', content:questionSent}); history = history.slice(-32);
        var reply = null;
        for (var index = 0; index < parts.length; index++) {
          if (current !== turn) return;
          thread.insertBefore(bubble(parts[index]), typing);
          if (!reply) { reply = {role:'assistant', content:parts[index]}; history.push(reply); }
          else reply.content += '\n\n' + parts[index];
          scrollToLatest(false);
        }
        typing.remove(); status.removeAttribute('aria-label');
        remember({m: parts.join('\n\n'), cards: Array.isArray(data.productCards) ? data.productCards.slice(0, 4) : [], currency: data.currency});
        renderCards(thread, Array.isArray(data.productCards) ? data.productCards : [], data.currency);
        var handoffExplained = /(?:pass|hand|refer|escalat|forward|connect|transfer).{0,70}(?:team|human|person|support)|(?:team|human|person).{0,70}(?:follow up|contact|reach|pick|reply)/i.test(parts.join(' '));
        if (data.collectEmail && handoffExplained) renderHandoff(thread);
        if (data.trackForm && !data.collectEmail) renderTrackForm(thread, data.trackPrefill);
        scrollToLatest(false);
      })
      .catch(function (error) {
        if (current !== turn) return;
        pending = []; typing.remove(); status.textContent = 'Couldn’t complete the answer';
        fail(thread, error.message === 'rate' ? 'Please wait a minute before trying again, or email our customer care team.' : 'Sorry, Happy Staffy Support couldn’t complete that answer. Try again or email our customer care team. No order changes have been made.', questionSent);
      })
      .finally(function () {
        clearTimeout(timer);
        if (current === turn) { active = null; scrollToLatest(false); }
      });
    return false;
  };
})();
